const initialState = {
  saving: false,
  edit: false,
  loading: false,
  formularySites: {},
  selectedFormularySite: '',
  siteTheme: {},
  values: {},
  validations: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LOADING_FORMULARY':
      return { ...state, loading: action.payload };
    case 'SET_SAVING_FORMULARY':
      return { ...state, saving: action.payload };
    case 'LOAD_SITE_THEME': {
      const newValidations = {};
      Object.keys(action.payload).forEach((validation) => {
        newValidations[validation] = true;
      });

      return {
        ...state,
        siteTheme: action.payload,
        values: action.payload,
        validations: newValidations,
      };
    }
    case 'EDIT_SITE_THEME': {
      let values = {};
      const validations = { ...state.validations, [action.id]: action.valid };

      if (action.categoryType) {
        if (action.categoryType === 'array') {
          values = { ...state.values, [action.category]: [action.value] };
        } else if (action.categoryType === 'object') {
          values = {
            ...state.values,
            [action.category]: { ...state.values[action.category], [action.id]: action.value },
          };
        } else if (action.categoryType === 'arrayWithinObject') {
          values = {
            ...state.values,
            [action.category]: {
              ...state.values[action.category],
              [action.objectKey]: [
                ...state.values[action.category][action.objectKey].map((b, i) => {
                  if (i === action.buttonNumber) {
                    return {
                      ...b,
                      [action.id]: action.value,
                    };
                  }
                  return b;
                }),

              ],
            },
          };
        }
      } else {
        values = { ...state.values, [action.id]: action.value };
      }
      return { ...state, values, validations };
    }
    case 'ADD_CONTENT_BOX_BUTTON': {
      const values = {
        ...state.values,
        [action.category]: {
          ...state.values[action.category],
          buttons: [
            ...state.values[action.category].buttons,
            { name: '', url: '' },
          ],
        },
      };

      return {
        ...state,
        values,
      };
    }
    case 'REMOVE_CONTENT_BOX_BUTTON': {
      const values = {
        ...state.values,
        [action.category]: {
          ...state.values[action.category],
          buttons: [
            ...state.values[action.category].buttons.slice(0, -1),
          ],
        },
      };

      return {
        ...state,
        values,
      };
    }
    case 'SELECT_FORMULARY_SITE':
      return { ...state, selectedFormularySite: action.payload };
    case 'LOAD_FORMULARY_SITES':
      return { ...state, formularySites: action.payload };
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
